import { createContext, useEffect, useState } from "react";
import { loginUser, refreshToken } from "../business/UserBusiness";
import api from "../services/api";

export const AuthContext = createContext()

export const AuthProvider = ({children}) => {

    const [user, setUser] = useState(null)
    const [customer, setCustomer] = useState(null)
    const [subscription, setSubscription] = useState(null)
    const [selectedClientId, setSelectedClientId] = useState(null);
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [isLoading, setIsLoading] = useState(false)
    const [isAdmin, setIsAdmin] = useState(false)
    // localStorage é síncrono, mas a leitura só roda dentro de um useEffect — na primeira
    // renderização da árvore inteira (visita direta a uma rota, ou reload da página) esse
    // efeito ainda não rodou, então `signed`/`isAdmin` aparecem falsos mesmo com sessão válida
    // guardada. AdminOnly/PrivateRoute usam essa flag pra não decidir redirecionar antes da
    // hidratação terminar — ver Gotchas.
    const [authChecked, setAuthChecked] = useState(false)

    console.log(`O usuário ativo é ${JSON.stringify(user)}`)

    const loadingStoredData = async () => {
        try {
            const storageUser = JSON.parse(localStorage.getItem("@Auth:user"));
            const storageToken = localStorage.getItem("@Auth:token");
            const storageName = localStorage.getItem("@Auth:name");
            const storageIsAdmin = localStorage.getItem("@Auth:isAdmin");

            if (storageToken && storageUser && storageName) {
                setUser(storageUser);
                setSubscription(storageUser?.subscriptionStatus);
                setIsAdmin(storageIsAdmin === 'true');
                console.log(`dados do usuário: ${JSON.stringify(storageUser)}`)
                console.log(JSON.stringify(localStorage.getItem("@Auth:Id")))
            }
        } catch (error) {
            console.error("Error loading stored data:", error);
        } finally {
            setAuthChecked(true)
        }
    };

    useEffect(() => {
        loadingStoredData();
    }, []);

    const setClient = (id) =>{
        setSelectedClientId(id);
    }

    const setTask = (id) => {
        setSelectedTaskId(id)
    }

    const signIn = async ({email, password}) => {
        try {
            const response = await loginUser({ email, password });
            
            if (response?.data?.error) {
                throw new Error(response.data.error);
            }

            const userData = response?.data?.user;
            const token = response?.data?.token;

            // Verificar se o usuário tem role "admin"
            if (userData?.role !== 'admin') {
                throw new Error('Acesso negado. Apenas administradores podem acessar o painel administrativo.');
            }

            setUser(userData);
            setSubscription(userData?.subscriptionStatus);
            setIsAdmin(true);
            
            // Configurar token no axios
            api.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            
            // Salvar no localStorage
            localStorage.setItem("@Auth:token", JSON.stringify(token));
            localStorage.setItem("@Auth:user", JSON.stringify(userData));
            localStorage.setItem("@Auth:Id", JSON.stringify(userData?.id));
            localStorage.setItem("@Auth:name", userData?.username);
            localStorage.setItem("@Auth:isAdmin", 'true');
            
            console.log("Login realizado com sucesso:", response?.data);
            
        } catch (error) {
            console.error("Erro no login:", error);
            throw error;
        }
    }

    const signOut = () => {
        localStorage.clear()
        setUser(null)
        setSubscription(null)
        setIsAdmin(false)
    }

    return(
        <AuthContext.Provider value={{
            user,
            subscription,
            selectedClientId,
            selectedTaskId,
            signed: !!user,
            isAdmin,
            authChecked,
            signIn,
            signOut,
            setClient,
            setTask
        }}>
            {children}
        </AuthContext.Provider>
    )
}